import { createFeature, createReducer, on } from "@ngrx/store";
import { AcsActions } from "./acs.actions";

export const acsFeatureKey = "acs";

export interface AcsCredentials {
    acsGroupId: string;
    acsUserId: string;
    acsToken: string;
    acsDisplayName: string;
}

export interface State {
    credentials: undefined | AcsCredentials;
}

export const initialState: State = {
    credentials: undefined,
};

export const reducer = createReducer(
    initialState,
    on(AcsActions.fetchAcsCredentialsSuccess, (state, { type, ...credentials }) => ({
        ...state,
        credentials,
    })),
);

export const acsFeature = createFeature({
    name: acsFeatureKey,
    reducer,
});

